import { Navigate } from 'react-router-dom';
import { useStore } from 'common/store';
import type { UseStoreValues } from 'common/types/store';
import { WORKBOARD_CURRENT_VALUATIONS_URL } from 'dashboard409a/common/config/urls';
import { getPreviousWorkboardRoute } from 'dashboard409a/utilities/navigation';

const WorkboardIndexRedirect = () => {
  const [{ user }] = useStore() as UseStoreValues;

  // The saved route is scoped per user, so wait until the user is known.
  if (!user?.id) {
    return null;
  }

  return <Navigate to={getPreviousWorkboardRoute(user.id) || WORKBOARD_CURRENT_VALUATIONS_URL} replace />;
};

export default WorkboardIndexRedirect;
